export enum SmsDirection {
    Inbound = 0,
    Outbound = 1
}